/*
HERO SLIDER
*/

jQuery(document).ready(function() {
	
	jQuery('.hs-wrap').slick({
		infinite: true,
		autoplay: true,
		speed: 600,
		fade: true,
		pauseOnHover: false
	  });

}); 